import { render, staticRenderFns } from "./PayPalAccount.vue?vue&type=template&id=bc1b4b64&scoped=true"
import script from "./PayPalAccount.vue?vue&type=script&lang=js"
export * from "./PayPalAccount.vue?vue&type=script&lang=js"
import style0 from "./PayPalAccount.vue?vue&type=style&index=0&id=bc1b4b64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc1b4b64",
  null
  
)

export default component.exports